import { MaskedLine, FadeUp } from "./Reveal";

const CHAPTERS = [
  {
    num: "01",
    title: "Built to Outlast",
    statement: "We don't build for the final inspection. We build for the thirty winters after it.",
    body: "Every footing is poured for the freeze-thaw cycle. Every frame is squared like it's load-bearing — because it is. Materials are specced for the North, not for the brochure.",
  },
  {
    num: "02",
    title: "One Crew, Every Trade",
    statement: "From excavation to the final coat of paint, the same standard holds the line.",
    body: "No hand-off gaps, no finger-pointing between subcontractors. You get one contract, one schedule, and one crew accountable for every square inch of the job.",
  },
  {
    num: "03",
    title: "Winter Is Home Turf",
    statement: "When the storm hits, we're already rolling. Snow removal isn't a side job — it's a discipline.",
    body: "GPS-tracked plows, 24/7 dispatch, and seasonal contracts that guarantee your lot is clear before your first coffee. The cold doesn't slow us down. It never has.",
  },
];

export const Manifesto = () => (
  <section id="about" className="py-24 sm:py-32 lg:py-48" data-testid="about-section">
    <div className="max-w-[1800px] mx-auto px-6 sm:px-12 lg:px-24">
      <FadeUp>
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#FF3B00] mb-8">About — The Manifesto</p>
      </FadeUp>
      <h2 className="font-oswald font-bold uppercase tracking-tight text-4xl sm:text-5xl lg:text-7xl leading-[0.95] max-w-5xl" data-testid="about-heading">
        <MaskedLine>We build like</MaskedLine>
        <MaskedLine delay={0.12}>our name is</MaskedLine>
        <MaskedLine delay={0.24}>
          <span className="text-[#FF3B00]">on the wall.</span>
        </MaskedLine>
      </h2>

      <div className="mt-24 lg:mt-32">
        {CHAPTERS.map((c, i) => (
          <div
            key={c.num}
            className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-12 py-16 lg:py-24 border-t border-[#262626]"
            data-testid={`manifesto-chapter-${c.num}`}
          >
            <div className="md:col-span-4 lg:col-span-3">
              <div className="md:sticky md:top-32">
                <FadeUp delay={0.05 * i}>
                  <span className="font-mono font-bold text-7xl lg:text-[9rem] leading-none text-outline block">
                    {c.num}
                  </span>
                  <span className="mt-4 block font-mono text-xs uppercase tracking-[0.3em] text-[#808080]">
                    {c.title}
                  </span>
                </FadeUp>
              </div>
            </div>
            <div className="md:col-span-8 lg:col-span-9">
              <FadeUp delay={0.1}>
                <h3 className="font-manrope font-bold text-2xl sm:text-3xl lg:text-5xl leading-tight text-[#F2F2F2] max-w-4xl">
                  {c.statement}
                </h3>
              </FadeUp>
              <FadeUp delay={0.2}>
                <p className="mt-8 text-base sm:text-lg font-light leading-relaxed text-[#808080] max-w-2xl">
                  {c.body}
                </p>
              </FadeUp>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
